<template>
  <!-- 事件管理 -->
  <div :class="['app-container', { 'bdc-list-page': isBdc, 'bdc-operate-aide-page': isBdc }]">
    <div class="chart-container">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-bottom:10px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>事件管理<el-tooltip class="item" effect="dark" content="在该页面进行事件的管理，包括设置事件的显示名、显示状态等" placement="right">
                    <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
                  </el-tooltip>
                </h5>

              </span>
            </div>
            <div>
              <el-button size="mini" icon="el-icon-circle-plus-outline" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px" @click="adddivshow">添加自定义事件</el-button>
              <el-select v-model="platformTypes" size="mini" placeholder="" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" @change="eventshaixuanplatformTypes">
                <el-option label="全部平台" value="" />
                <el-option label="服务端事件" value="1" />
                <el-option label="客户端事件" value="2" />
                <el-option label="USDK埋点事件" value="3" />

              </el-select>
              <el-select v-model="eventTypeselect" size="mini" placeholder="" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" @change="eventshaixuaneventTypeselect">
                <el-option label="全部事件" value="" />
                <el-option label="公共事件" value="0" />
                <el-option label="自定义事件" value="1" />
              </el-select>
              <el-input v-model="eventNames" size="mini" style="width:260px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" placeholder="事件名称/事件编码/事件描述模糊查询" clearable />
              <el-button type="primary" size="mini" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" @click="mohuchaxun">查询</el-button>

              <div v-if="!isBdc" style="float:right;margin-right:10px;cursor: pointer;margin-left:10px" title="下载">
                <el-button size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="exportExcel($event)" />
              </div>
              <el-table :stripe="!isBdc" :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="tableData1.slice((currentPage1-1)*sizePage1,currentPage1*sizePage1)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1'" style="width: 100%" border @filter-change="filterplatformType" @sort-change="handleAgeSortChangeevent" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
                <el-table-column prop="eventCode" label="事件编码" min-width="80">
                  <template slot-scope="scope">
                    <span style="color:#646cf5;cursor: pointer;" @click="chakanxiangqing(scope.$index, scope.row)">
                      {{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="eventName" label="事件名称" min-width="120" show-overflow-tooltip />
                <el-table-column prop="eventDesc" label="事件描述" width="300" show-overflow-tooltip />
                <el-table-column prop="platformType" label="平台类型" min-width="120" :filters="[ { text: '服务端事件', value: '1' }, { text: '客户端事件', value: '2' }, { text: 'USDK埋点事件', value: '3' } ]" :filter-multiple="false" column-key="platformType" filter-placement="bottom-end">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | platformTypes }}
                  </template>
                </el-table-column>
                <el-table-column prop="eventType" label="事件类型" min-width="120" :filters="[ { text: '公共事件', value: '0' }, { text: '自定义事件', value: '1' }]" :filter-multiple="false" column-key="eventType" filter-placement="bottom-end">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | eventTypes }}
                  </template>
                </el-table-column>
                <el-table-column prop="isShow" label="显示状态" min-width="100" :filters="[ { text: '显示', value:true }, { text: '隐藏', value: false }]" :filter-multiple="false" column-key="isShow" filter-placement="bottom-end">
                  <template slot-scope="scope">
                    <el-switch v-model="scope.row[scope.column.property]" active-color="#13ce66" inactive-color="#ff4949" @change="eventshowschange($event,scope.$index, scope.row,'event')" />
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="upTimeStr" label="上报时间" min-width="130" sortable='custom'>
                </el-table-column> -->
                <el-table-column label="操作" width="160">
                  <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button v-if="scope.row.eventType==1" type="text" class="bdc-table-op-muted" @click="zidingyishijianupdate(scope.$index, scope.row)">编辑</el-button>
                      <el-button v-if="scope.row.eventType==1" type="text" class="bdc-table-op-danger" @click="zidingyishijiandelete(scope.$index, scope.row)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <bdc-table-footer>
                <template #actions>
                  <bdc-download-button @click="exportExcel($event)" />
                </template>
                <pagination
                  v-show="dataLength1 > 0"
                  :auto-scroll="false"
                  :background="!isBdc"
                  :total="dataLength1"
                  :page.sync="currentPage1"
                  :limit.sync="sizePage1"
                  :page-sizes="[10, 15, 20, 30, 50]"
                  :class="isBdc ? 'bdc-table-pagination' : ''"
                />
              </bdc-table-footer>
              <el-table id="xiazaishijian" style="display: none;" :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="tableData1" class="tb-edit tb-edit1">
                <el-table-column prop="eventCode" label="事件编码" min-width="80" />
                <el-table-column prop="eventName" label="事件名称" min-width="120" />
                <el-table-column prop="eventDesc" label="事件描述" width="300" />
                <el-table-column prop="platformType" label="平台类型" min-width="120">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | platformTypes }}
                  </template>
                </el-table-column>
                <el-table-column prop="eventType" label="事件类型" min-width="120">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | eventTypes }}
                  </template>
                </el-table-column>
                <el-table-column prop="isShow" label="显示状态" min-width="100">
                  <template slot-scope="scope">
                    <span v-if="scope.row[scope.column.property]">显示</span>
                    <span v-else>隐藏</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="upTimeStr" label="上报时间" min-width="130">
                </el-table-column> -->
              </el-table>

            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 公共事件详情 -->
      <el-dialog :title="shijianxiangqing" :visible.sync="dialogTableVisible" custom-class="bdc-operate-aide-dialog" width="90%" top="8vh">
        <div>
          <!-- v-if="eventTypesis == '1'"  -->
          <el-button size="mini" icon="el-icon-circle-plus-outline" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px" @click="adddivshowcanshu">添加自定义参数
          </el-button>
          <el-button size="mini" icon="el-icon-upload" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px" @click="uploaddiv = true">批量上传
          </el-button>
          <el-select v-model="eventTypeselect1" size="mini" placeholder="全部属性" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px">
            <el-option label="全部属性" value="" />
            <el-option label="公共属性" value="0" />
            <el-option label="自定义属性" value="1" />
            <el-option label="虚拟属性" value="2" />
          </el-select>
          <el-select v-model="dataTypeselect1" size="mini" placeholder="数据类型" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px">
            <el-option label="全部类型" value="" />
            <el-option v-for="item in dataTypesarr" :key="item.value" :label="item.text" :value="item.value" />
          </el-select>
          <el-input v-model="zj_eventNames" size="mini" style="width:260px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" placeholder="参数名/显示名/参数描述模糊查询" clearable />
          <el-button type="primary" size="mini" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" @click="mohuchaxun1">查询</el-button>
        </div>
        <!-- @filter-change="filterplatformType3" -->
        <el-table ref="detailTable" v-loading="modelloading2" :stripe="!isBdc" :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="tableData2.slice((currentPage2-1)*sizePage2,currentPage2*sizePage2)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1'" style="width: 100%; min-height:485px" border @sort-change="handleAgeSortChangeeventdata" @filter-change="filterChange" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
          <el-table-column prop="dataKey" label="参数名" min-width="120" sortable="custom">
            <template slot-scope="scope">
              <span v-if="scope.row.sysType == '2'">#vp@</span>{{ scope.row[scope.column.property] }}
            </template>
          </el-table-column>
          <el-table-column prop="dataName" label="显示名" show-overflow-tooltip min-width="100" sortable="custom" />
          <el-table-column prop="dataDesc" label="参数描述" show-overflow-tooltip min-width="200" sortable="custom" />
          <el-table-column prop="ruleText" label="校验规则" show-overflow-tooltip min-width="120" sortable="custom" />
          <el-table-column prop="dictType" label="字典关联名称" min-width="150" sortable="custom">
            <template slot="header" slot-scope="scope">
              <span class="bdc-table-header-with-tip">
                字典关联名称
                <el-tooltip class="item" effect="dark" content="可在字典管理或编辑操作中进行配置" placement="right">
                  <span class="bdc-table-header-tip-trigger">
                    <bdc-help-icon />
                  </span>
                </el-tooltip>
              </span>
            </template>
          </el-table-column>
          <!-- :filters="dataTypesarr" :filter-multiple='false' column-key="dataType" filter-placement="bottom-end" :filter-method="filterHandler" -->
          <el-table-column prop="dataType" label="数据类型" min-width="100">
            <template slot-scope="scope">
              {{ scope.row[scope.column.property] | dataTypes(dataTypesarr) }}
            </template>
          </el-table-column>
          <!-- :filters="[ { text: '公共属性', value: '2' }, { text: '自定义属性', value: '1' }]" :filter-multiple='false' column-key="sysType"
            filter-placement="bottom-end" -->
          <el-table-column prop="sysType" label="属性类型" min-width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.sysType == '1'">自定义属性</span>
              <span v-if="scope.row.sysType == '0'">公共属性</span>
              <span v-if="scope.row.sysType == '2'">虚拟属性</span>
            </template>
          </el-table-column>
          <el-table-column prop="dataEmpty" label="是否必填" min-width="100" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row[scope.column.property] | dataEmptys }}
            </template>
          </el-table-column>
          <!-- :filters="[ { text: '显示', value:true }, { text: '隐藏', value: false }]" :filter-multiple='false' column-key="isShow" filter-placement="bottom-end" -->
          <el-table-column prop="isShow" label="显示状态" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row[scope.column.property]" active-color="#13ce66" inactive-color="#ff4949" @change="eventshowschange($event,scope.$index, scope.row,'eventData')" />
            </template>
          </el-table-column>

          <!-- :filter-multiple="false" -->
          <el-table-column prop="status" column-key="status" :filters="[{text: '生效', value: 1}, {text: '未生效', value: 0}, {text: '添加中', value: 2}]" label="是否生效" :filter-multiple="false" min-width="130">
            <template slot="header" slot-scope="scope">
              <span class="bdc-table-header-with-tip">
                是否生效
                <el-tooltip class="item" effect="dark" content="代表该属性是否已被BDC维护入库；属性生效后才可正常查询，且生效属性不能删除。" placement="right">
                  <span class="bdc-table-header-tip-trigger">
                    <bdc-help-icon />
                  </span>
                </el-tooltip>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ {0: '未生效', 1: '生效', 2: '添加中'}[scope.row[scope.column.property]] }}</span>
            </template>
          </el-table-column>

          <!-- 必传校验 -->
          <el-table-column prop="isCheck" column-key="isCheck" :filters="[{text: '校验', value: true}, {text: '不校验', value: false}]" label="必传校验" :filter-multiple="false" min-width="130">
            <template slot="header" slot-scope="scope">
              <span class="bdc-table-header-with-tip">
                必传校验
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content">用于标记属性是否为事件下的必传字段；<br />开启时，会在日志查看的格式校验中校验该属性是否上传；<br />关闭时，则不会校验，即事件中没有上传该属性也不会提示缺少参数。</div>
                  <span class="bdc-table-header-tip-trigger">
                    <bdc-help-icon />
                  </span>
                </el-tooltip>
              </span>
            </template>
            <template slot-scope="scope">
              <el-switch :disabled="scope.row.sysType != '1'" v-model="scope.row[scope.column.property]" active-color="#13ce66" inactive-color="#ff4949" @change="eventCheckchange($event,scope.$index, scope.row,'eventData')" />
            </template>
          </el-table-column>

          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <div class="bdc-table-op-cell">
                <el-button type="text" class="bdc-table-op-muted" @click="zidingyishijianshuxingupdate(scope.$index, scope.row)">编辑</el-button>
                <el-button v-if="scope.row.sysType == '1' &&  scope.row.status == 0" type="text" class="bdc-table-op-danger" @click="zidingyishijianshuxingdelete(scope.$index, scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <bdc-table-footer>
          <pagination
            v-show="dataLength2 > 0"
            :auto-scroll="false"
            :background="!isBdc"
            :total="dataLength2"
            :page.sync="currentPage2"
            :limit.sync="sizePage2"
            :page-sizes="[10, 15, 20, 30, 50]"
            :class="isBdc ? 'bdc-table-pagination' : ''"
            @pagination="handleEventDetailPagination"
          />
        </bdc-table-footer>
      </el-dialog>
      <!-- 添加自定义事件 -->
      <el-dialog title="添加自定义事件" :visible.sync="adddivif" custom-class="bdc-operate-aide-dialog" :close-on-click-modal="false" width="500px">
        <el-form ref="form" :inline="true" :model="form" label-width="120px">
          <el-form-item label="平台类型">
            <el-radio-group v-model="form.platformType" @change="form.eventCode=''">
              <el-radio :label="1">服务端</el-radio>
              <el-radio :label="2">客户端</el-radio>
              <el-radio v-if="['admin', 'vip'].filter(item => roles.includes(item)).length" :label="3">USDK埋点</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="事件编码">
            <el-input v-if="form.platformType!=3" v-model="form.eventCode" style="width:200px" @input="form.eventCode=form.eventCode.replace(/[^\d]/g,'')" />
            <el-input v-if="form.platformType==3" v-model="form.eventCode" style="width:200px" @input="form.eventCode=form.eventCode.replace(/[^\dA-Za-z_]/g,'')" />
          </el-form-item>
          <el-form-item label="事件名称">
            <el-input v-model="form.eventName" style="width:200px" />
          </el-form-item>
          <el-form-item label="事件描述">
            <el-input v-model="form.eventDesc" type="text   area" style="width:200px" />
          </el-form-item>

          <el-form-item label="显示状态">
            <el-switch v-model="form.isShow" active-color="#13ce66" inactive-color="#ff4949" />
            <el-tooltip class="item" effect="dark" content="是否显示" placement="right">
              <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
            </el-tooltip>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer bdc-dialog-footer-actions">
          <el-button @click="hidedivshow">取消</el-button>
          <el-button type="primary" @click="onSubmit">创 建</el-button>
        </span>
      </el-dialog>

      <!-- 编辑自定义事件 -->
      <el-dialog title="编辑自定义事件" :visible.sync="updatedivif" custom-class="bdc-operate-aide-dialog" :close-on-click-modal="false" width="500px" top="5vh">
        <el-form ref="form" :inline="true" :model="uform" label-width="120px">
          <el-form-item label="平台类型">
            <!-- {{uform.platformType | platformTypes}} -->
            <!-- <el-input v-model="uform.platformType | platformTypes" disabled style="width:200px"></el-input> -->
            <el-radio-group v-model="uform.platformType" disabled>
              <el-radio :label="'1'">服务端</el-radio>
              <el-radio :label="'2'">客户端</el-radio>
              <el-radio :label="'3'">USDK埋点</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="事件编码">
            <el-input v-model="uform.eventCode" disabled style="width:200px" />
          </el-form-item>
          <el-form-item label="事件名称">
            <el-input v-model="uform.eventName" style="width:200px" />
          </el-form-item>
          <el-form-item label="事件描述">
            <el-input v-model="uform.eventDesc" type="textarea" style="width:200px" />
          </el-form-item>

          <el-form-item label="显示状态">
            <el-switch v-model="uform.isShow" active-color="#13ce66" inactive-color="#ff4949" />
            <el-tooltip class="item" effect="dark" content="是否显示" placement="right">
              <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
            </el-tooltip>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer bdc-dialog-footer-actions">
          <el-button @click="hidedivshowuform">取消</el-button>
          <el-button type="primary" @click="onSubmituform">保存修改</el-button>
        </span>
      </el-dialog>
      <!-- 添加自定义参数  :stripe="!isUpload" :row-class-name="tableRowClassName"-->
      <el-dialog :title="UploadOrAdd?uploadText:'添加事件属性'" :visible.sync="adddivifcanshu" custom-class="bdc-operate-aide-dialog" :close-on-click-modal="false" width="96%" top="5vh" center>
        <el-table :data="shijianshuxinglist" :stripe="!isBdc" border :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1'" style="width: 100%" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
          <el-table-column v-if="shijianshuxinglist.length>1" key="column1" width="55">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-remove-outline" style="padding:3px 3px" title="删除此行" @click="shijianshuxinglistdelete(scope.$index, scope.row)" />
            </template>
          </el-table-column>
          <el-table-column key="column2" label="参数名" min-width="130">
            <template slot-scope="scope">
              <el-autocomplete v-model="scope.row.dataKey" value-key="dataKey" size="mini" style="width:100%" :fetch-suggestions="querySearch" placeholder="由“小写字母”或 “小写字母+数字/下划线”组成" clearable @select="handleSelect($event,scope.row)" />

            </template>
          </el-table-column>
          <el-table-column key="column3" label="参数类型" min-width="120">
            <template slot-scope="scope">
              <el-select v-model="scope.row.dataType" placeholder="参数类型" size="mini">
                <el-option v-for="selectvalue in dataTypes" :key="selectvalue.dataTypeName" :label="selectvalue.dataTypeName" :value="selectvalue.dataType" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column key="column4" label="参数显示名" min-width="130">
            <template slot-scope="scope">
              <el-input v-model="scope.row.dataName" placeholder="参数显示名" size="mini" />
            </template>
          </el-table-column>
          <el-table-column key="column5" label="参数规则" min-width="130">
            <template slot-scope="scope">
              <el-select v-model="scope.row.ruleType" placeholder="参数规则" size="mini">
                <el-option v-for="selectvalue in ruleTypes" :key="selectvalue.ruleText" :label="selectvalue.ruleText" :value="selectvalue.ruleType" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column key="column16" prop="sysType" label="属性类型" min-width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.sysType == '1'">自定义属性</span>
              <span v-else-if="scope.row.sysType == '0'">公共属性</span>
              <span v-else-if="scope.row.sysType == '2'">虚拟属性</span>
              <span v-else>自定义属性</span>
            </template>
          </el-table-column>
          <el-table-column key="column6" width="130">
            <template slot="header" slot-scope="scope">
              <span class="bdc-table-header-with-tip">
                是否必填
                <el-tooltip class="item" effect="dark" content="是否必填" placement="right">
                  <span class="bdc-table-header-tip-trigger">
                    <bdc-help-icon />
                  </span>
                </el-tooltip>
              </span>
            </template>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.dataEmpty" active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" />
            </template>
          </el-table-column>
          <el-table-column key="column7" label="参数描述" width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.dataDesc" size="mini" type="textarea" :rows="1" placeholder="参数描述" />
            </template>
          </el-table-column>
          <el-table-column key="column8" width="130">
            <template slot="header" slot-scope="scope">
              <span class="bdc-table-header-with-tip">
                显示状态
                <el-tooltip class="item" effect="dark" content="是否显示" placement="right">
                  <span class="bdc-table-header-tip-trigger">
                    <bdc-help-icon />
                  </span>
                </el-tooltip>
              </span>
            </template>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.isShow" active-color="#13ce66" inactive-color="#ff4949" />
            </template>
          </el-table-column>
          <!-- 必传校验 -->
          <el-table-column key="column18" width="130">
            <template slot="header" slot-scope="scope">
              <span class="bdc-table-header-with-tip">
                必传校验
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content">用于标记属性是否为事件下的必传字段；<br />开启时，会在日志查看的格式校验中校验该属性是否上传；<br />关闭时，则不会校验，即事件中没有上传该属性也不会提示缺少参数。</div>
                  <span class="bdc-table-header-tip-trigger">
                    <bdc-help-icon />
                  </span>
                </el-tooltip>
              </span>
            </template>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.isCheck" active-color="#13ce66" inactive-color="#ff4949" />
            </template>
          </el-table-column>
          <el-table-column v-if="isUpload" key="column9" label="解析结果" min-width="300">
            <template slot-scope="scope">
              <span v-if="scope.row.verificationPassed" style="color:#24915A">
                <svg-icon icon-class="chenggong" />
                <span style="font-size:14px" v-html="scope.row.tipMessage" />
              </span>
              <span v-else style="color:#E22B4B">
                <svg-icon icon-class="cuowu" />
                <span style="font-size:14px" class="br_style" v-html="scope.row.tipMessage" />
              </span>
            </template>
          </el-table-column>
        </el-table>

        <span slot="footer" class="dialog-footer bdc-dialog-footer-split">
          <el-button type="success" icon="el-icon-circle-plus-outline" @click="shijianshuxinglistadd">加一行</el-button>
          <div class="bdc-dialog-footer-actions">
            <el-button @click="adddivifcanshu = false">取 消</el-button>
            <el-button type="primary" @click="baocunshijianshuxinglist">创建并保存</el-button>
          </div>
        </span>

      </el-dialog>
      <!-- 编辑自定义参数 -->
      <el-dialog title="编辑自定义参数" :visible.sync="updatedivifcanshu" custom-class="bdc-operate-aide-dialog" :close-on-click-modal="false" width="400px" top="5vh">
        <div style="color:#ff6161;font-size:10px;width:100%;text-align: center;padding-bottom:15px">属性参数“仅支持相同含义”的修改，否则请先删除，然后重新创建</div>
        <el-form ref="form" :inline="true" :model="csuform" label-width="120px">
          <el-form-item label="参数名">
            <el-input v-model="csuform.dataKey" disabled style="width:200px" />
          </el-form-item>
          <el-form-item label="参数类型">
            <el-select v-model="csuform.dataType" disabled placeholder="参数类型" size="small" style="margin-left:1px;width:230px;height:28px;line-height:28px;width:200px">
              <el-option v-for="selectvalue in dataTypes" :key="selectvalue.dataTypeName" :label="selectvalue.dataTypeName" :value="selectvalue.dataType" />
            </el-select>
          </el-form-item>
          <el-form-item label="参数规则">
            <el-select v-model="csuform.ruleType" disabled placeholder="参数规则" size="small" style="margin-left:1px;width:230px;height:28px;line-height:28px;width:200px">
              <el-option v-for="selectvalue in ruleTypes" :key="selectvalue.ruleText" :label="selectvalue.ruleText" :value="selectvalue.ruleType" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否必填">
            <el-switch v-model="csuform.dataEmpty" disabled active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" />
          </el-form-item>
          <el-form-item label="参数描述">
            <el-input v-model="csuform.dataDesc" :disabled="this.dismiaoshu != '1'" type="textarea" style="width:200px" />
          </el-form-item>
          <el-form-item label="参数显示名">
            <el-input v-model="csuform.dataName" style="width:200px" />
          </el-form-item>
          <el-form-item label="显示状态">
            <el-switch v-model="csuform.isShow" active-color="#13ce66" inactive-color="#ff4949" />
            <el-tooltip class="item" effect="dark" content="显示状态" placement="right">
              <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
            </el-tooltip>
          </el-form-item>
          <!-- 必传校验 -->
          <el-form-item label="必传校验">
            <el-switch :disabled="csuform.sysType!='1'" v-model="csuform.isCheck" active-color="#13ce66" inactive-color="#ff4949" />
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content">用于标记属性是否为事件下的必传字段；<br />开启时，会在日志查看的格式校验中校验该属性是否上传；<br />关闭时，则不会校验，即事件中没有上传该属性也不会提示缺少参数。</div>
              <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
            </el-tooltip>
          </el-form-item>
          <!-- <el-form-item label="关联字典">
            <el-select placeholder="所有字典" filterable clearable v-model="aaa">
              <el-option value="1">111</el-option>
              <el-option value="2">222</el-option>
            </el-select>
            <el-tooltip class="item" effect="dark" content="选择关联字典" placement="right">
              <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
            </el-tooltip>
          </el-form-item>
          <el-form-item label="字典父级">
            <el-select placeholder="字典父级" filterable clearable v-model="bbb">
              <el-option value="1">111</el-option>
              <el-option value="2">222</el-option>
            </el-select>
            <el-tooltip class="item" effect="dark" content="选择关联字典" placement="right">
              <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
            </el-tooltip>
          </el-form-item>
          <el-form-item label="父级绑定参数">
            <el-select placeholder="父级绑定参数" filterable clearable v-model="ccc">
              <el-option value="1">111</el-option>
              <el-option value="2">222</el-option>
            </el-select>
            <el-tooltip class="item" effect="dark" content="选择关联字典" placement="right">
              <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
            </el-tooltip>
          </el-form-item>
          <el-form-item label="父级字典标签">
            <el-select placeholder="父级字典标签" filterable clearable v-model="ddd">
              <el-option value="1">111</el-option>
              <el-option value="2">222</el-option>
            </el-select>
            <el-tooltip class="item" effect="dark" content="选择关联字典" placement="right">
              <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
            </el-tooltip>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer bdc-dialog-footer-actions">
          <el-button @click="updatedivifcanshu = false">取消</el-button>
          <el-button type="primary" @click="onSubmitcsuform">保存修改</el-button>
        </span>
      </el-dialog>

      <el-dialog title="批量上传" :visible.sync="uploaddiv" custom-class="bdc-operate-aide-dialog" :close-on-click-modal="false" width="460px" top="5vh">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="第一步：" style="margin-bottom:0px">
            下载
            <a target="_blank" :href="`${publicPath}事件管理字段批量上传模板.xlsx`" download="事件管理字段批量上传模板.xlsx">
              <el-button slot="trigger" size="small" type="text">《事件管理字段批量上传模板》</el-button>
            </a>
          </el-form-item>
          <el-form-item label="第二步：">
            上传填写好的模板
            <el-upload ref="upload" style="width:350px;" class="upload-demo" action="" :on-preview="handlePreview" :on-change="handlechange" :on-remove="handleRemove" :file-list="fileList" :auto-upload="false" @on-exceed="exceedFileList" accept=".xls;*.xlsx;">
              <el-button slot="trigger" size="small" type=""><i class="el-icon-upload2" /> 上传文件</el-button>
              <div slot="tip" class="el-upload__tip">提示：需严格按照模板格式进行上传，支持xls、xlsx格式</div>
            </el-upload>

          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer bdc-dialog-footer-actions">
          <el-button @click="uploaddivClick">取消</el-button>
          <el-button type="primary" @click="onSubmitupload">上传</el-button>
        </span>
      </el-dialog>

      <el-row :gutter="20">
        <el-col :span="24" style="margin-bottom:20px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="width: 100%;">
              <span>
                <h5>日志汇总</h5>
              </span>
            </div>
            <el-tabs v-model="rz_timetype" type="card" style="margin-top:20px;" @tab-click="timetypehandleClick">
              <el-tab-pane label="按天汇总" name="1D" />
              <el-tab-pane label="按月汇总" name="1M" />
              <el-tab-pane label="按年汇总" name="1Y" />
            </el-tabs>

            <div v-loading="modelloading" style="width:100%;float:left;min-height:500px;border:1px solid #dedede;border-top:none;margin-bottom:20px;">
              <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'6px 6px !important'}" :data="rz_tableData3.tbody" class="tb-edit tb-edit1" border height="403px">
                <el-table-column v-for="(itemtable,index) in rz_tableData3.thead" :key="itemtable.label" :label="itemtable.label" :property="itemtable.property">
                  <template slot-scope="scope">
                    <span v-if="index==0" style="color:#646cf5;cursor: pointer;" @click="rz_chakanxiangqing(scope.$index, scope.row)">
                      {{ scope.row[scope.column.property] }}
                    </span>
                    <span v-else>
                      {{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                </el-table-column>

              </el-table>
              <el-alert :title="rz_jiezhihuizong" type="success" :closable="false" style="width:98%;margin-left:1%" />
              <bdc-table-footer>
                <pagination
                  v-show="rz_dataLength3 > 0"
                  :auto-scroll="false"
                  :background="!isBdc"
                  :total="rz_dataLength3"
                  :page.sync="rz_querydata.pageNo"
                  :limit.sync="rz_querydata.pageSize"
                  :page-sizes="[10, 15, 20, 30, 50]"
                  :class="isBdc ? 'bdc-table-pagination' : ''"
                  @pagination="handleRzSummaryPagination"
                />
              </bdc-table-footer>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-dialog :title="rz_shijianxiangqing" :visible.sync="rz_dialogTableVisible" custom-class="bdc-operate-aide-dialog" width="80%" top="8vh">
        <el-table v-loading="modelloading1" :stripe="!isBdc" :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="rz_tableData2.tbody.slice((rz_currentPage2-1)*rz_sizePage2,rz_currentPage2*rz_sizePage2)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1'" height="403" style="width: 100%; margin-top: 0" border @sort-change="handleAgeSortChange" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
          <el-table-column v-for="itemtable in rz_tableData2.thead" :key="itemtable.label" :label="itemtable.label" :property="itemtable.property" sortable="custom" />
        </el-table>
        <bdc-table-footer>
          <pagination
            v-show="rz_dataLength2 > 0"
            :auto-scroll="false"
            :background="!isBdc"
            :total="rz_dataLength2"
            :page.sync="rz_currentPage2"
            :limit.sync="rz_sizePage2"
            :page-sizes="[10, 15, 20, 30, 50]"
            :class="isBdc ? 'bdc-table-pagination' : ''"
            @pagination="handleRzDetailPagination"
          />
        </bdc-table-footer>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import {
  ajax_eventqueryEventList,
  ajax_eventupdateShow,
  ajax_eventupdateCheck,
  ajax_eventsaveEvent,
  ajax_eventdeleteEventById,
  ajax_eventqueryEventDataList,
  ajax_eventsaveEventDataList,
  ajax_eventsaveEventData,
  ajax_eventdeleteEventDataById,
  ajax_eventimportEventData,
  ajax_eventimportEventDataAndVerification,
  ajax_eventdataqueryData,

  queryRuleList,
  queryTypeList,

  ajax_model4
} from '@Bdc~/api/ajax_model'

import FileSaver from 'file-saver'
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcDownloadButton from '@/components/BdcTableFooter/BdcDownloadButton'
import bdcTableCrosshair from '@Bdc~/utils/bdcTableCrosshair'
import * as XLSX from 'xlsx'
import { parse } from 'path-to-regexp'
import { mapGetters } from 'vuex'

export default {
  name: 'Metaevent',
  components: { Pagination, BdcTableFooter, BdcDownloadButton },
  mixins: [bdcTableCrosshair],
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    },
    ...mapGetters([
      'sidebar',
      'roles'
    ])
  },
  data() {
    return {
      isAdmin_Vip: this.$store.getters.roles.indexOf('admin') > -1 || this.$store.getters.roles.indexOf('vip') > -1,
      uploadText: '',
      isUpload: false,
      UploadOrAdd: false,
      publicPath: process.env.BASE_URL,
      aaa: '',
      bbb: '',
      ccc: '',
      ddd: '',

      zidian: '',
      shijianshuxinglist: [{
        dataKey: '',
        dataType: '1',
        dataName: '',
        ruleType: '0',
        dataEmpty: '1',
        dataDesc: '',
        isShow: true,
        sysType: '1',
        isCheck: true,
      }],

      uploaddiv: false,
      fileList: [],

      form: {
        appkey: this.$store.getters.appkey,
        eventCode: '',
        platformType: 1,
        eventName: '',
        eventDesc: '',
        isShow: true
      },
      uform: {
        id: '',
        appkey: this.$store.getters.appkey,
        eventCode: '',
        platformType: 1,
        eventName: '',
        eventDesc: '',
        isShow: false
      },
      csform: {
        dataKey: '',
        dataType: '1',
        dataName: '',
        ruleType: '0',
        dataEmpty: '1',
        dataDesc: '',
        isShow: true,
        sysType: '1',
        isCheck: true,
      },
      csuform: {
        id: '',
        appkey: '',
        sasEventCode: '',
        dataKey: '',
        dataType: '',
        dataName: '',
        dataDesc: '',
        dataEmpty: '',
        isShow: true,
        ruleType: '',
        sysType: '1',
        isCheck: true,
      },
      adddivif: false,
      updatedivif: false,
      eventdivif: false,
      dialogTableVisible: false,
      adddivifcanshu: false,
      updatedivifcanshu: false,
      shijianxiangqing: '',
      platformTypes: '',
      eventTypeselect: '',
      eventNames: '',
      isShows: '',
      isChecks: '',
      platformTypeszidingyi: '',
      eventcode: '',
      eid: '',
      eventTypesis: '',
      dismiaoshu: '2',

      tiaojian1: {
        eventType: '',
        isShow: '',
        appkey: this.$store.getters.appkey,
        dataType: '',
        findStr: '',
        dataEmpty: '',
        sysType: '',
        isCheck: ''
      },
      EventAttributeListData: [],
      EventAttributeListDataCopy: [],

      eventTypeselect1: '',
      dataTypeselect1: '',

      dataTypes: [],
      ruleTypes: [],
      dataTypesarr: [],

      zdydialogTableVisible: false,
      zdyshijianxiangqing: '',

      tableData: [],
      currentPage: 1,
      dataLength: 1,
      sizePage: 10,

      tableData1: [],
      tableData1copy: [],
      currentPage1: 1,
      dataLength1: 1,
      sizePage1: 10,

      tableData2: [],
      tableData2copy: [],
      currentPage2: 1,
      dataLength2: 1,
      sizePage2: 10,

      rz_timetype: '1D',
      rz_shijianxiangqing: '',
      rz_dialogTableVisible: false,
      rz_tableData3: {},
      rz_currentPage3: 1,
      rz_dataLength3: 1,
      rz_sizePage3: 10,
      rz_querydata: {
        pageSize: 10,
        pageNo: 1
      },

      rz_tableData2: { tbody: [], thead: [] },
      rz_tableData2copy: {},
      rz_currentPage2: 1,
      rz_dataLength2: 1,
      rz_sizePage2: 10,

      rz_querydatalist: {
        pageSize: 10,
        pageNo: 1
      },
      rz_jiezhihuizong: '',
      modelloading: false,
      modelloading1: false,
      modelloading2: false,

      zj_eventNames: '',
      filters: {}
    }
  },
  created() {
    this.EventAttributeList()
    this.queryEventList()
    this.queryRuleList()
    this.queryTypeList()
    this.rizhihuizongdata()
  },
  mounted() { },
  methods: {
    // 事件属性列表
    EventAttributeList() {
      ajax_eventdataqueryData(this.tiaojian1).then(
        response => {
          console.log('事件属性列表', response)
          if (response.code == 1) {
            this.EventAttributeListDataCopy = JSON.parse(JSON.stringify(response.data))
            this.EventAttributeListData = response.data
          }
        }
      )
    },
    handleSelect(item, row) {
      console.log(item, row)
      row.dataDesc = item.dataDesc
      row.dataEmpty = item.dataEmpty + ''
      row.dataName = item.dataName
      row.dataType = item.dataType + ''
      row.isShow = item.isShow
      row.ruleType = item.ruleType + ''
    },
    querySearch(queryString, cb) {
      var restaurants = this.EventAttributeListData
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.dataKey.toLowerCase().indexOf(queryString.toLowerCase()) > -1)
      }
    },

    handlePreview(file) {
      console.log(file)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    exceedFileList(file, fileList) {
      console.log(file, fileList)
    },
    handlechange(file, fileList) {
      console.log(file, fileList)
      this.UploadOrAdd = true
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]//这一步，是 展示最后一次选择文件
      }
      this.uploadText = '《 ' + file.name + ' 》预览'
    },
    tableRowClassName({ row, rowIndex }) {
      if (!this.isUpload) {
        return true
      } else {
        if (row.verificationPassed === true) {
          return 'success-row'
        }
        if (row.verificationPassed === false) {
          return 'warning-row'
        }
      }
    },
    uploaddivClick() {
      this.uploaddiv = false
      this.fileList = []
    },
    onSubmitupload() {
      var fd = ''
      fd = new FormData()
      fd.append('appkey', this.$store.getters.appkey)
      fd.append('sasEventCode', this.eventcode)
      if (this.fileList.length > 0) {
        // 添加文件对象

        fd.append('file', this.fileList[0].raw)
      } else {
        this.fileList = []
        this.$message({
          type: 'warning',
          message: '请点击选取文件'
        })
        return false
      }
      console.log(fd)

      ajax_eventimportEventDataAndVerification(fd).then(response => {
        if (response.code == 1) {
          this.fileList = []
          this.uploaddiv = false
          this.adddivifcanshu = true
          this.isUpload = true

          var reg = new RegExp('<br/>', 'g')
          var idata = 0
          response.data.forEach(item => {
            item.dataType += ''
            item.ruleType += ''
            item.dataEmpty += ''
            item.sysType += ''
            item.tipMessage = (item.tipMessage && item.tipMessage.indexOf('<br/>') > -1) ? item.tipMessage.replace(reg, '&nbsp;；&nbsp;&nbsp;&nbsp;&nbsp;') : ''
            if (item.tipMessage && item.tipMessage != '') {
              idata++
            }
          })

          if (idata != 0) {
            this.$message.warning('有异常参数，请修改后再进行保存')
          }
          this.shijianshuxinglist = response.data
        }
      })

      // ajax_eventimportEventData(fd).then(response => {
      //   if (response.code == 1) {
      //     this.$message.success("上传成功:" + response.data);
      //     this.fileList = [];
      //     this.uploaddiv = false;
      //     this.queryEventDataList();
      //   }
      // });
    },

    shuxingquchong() {
      // this.EventAttributeListDataCopy
      // this.tableData2
      this.EventAttributeListData = []
      var nt = new Date()
      for (var i = 0; i < this.EventAttributeListDataCopy.length; i++) {
        var istrue = true
        for (var j = 0; j < this.tableData2.length; j++) {
          if (this.EventAttributeListDataCopy[i].dataKey == this.tableData2[j].dataKey) {
            istrue = false
          }
        }
        if (istrue) {
          this.EventAttributeListData.push(this.EventAttributeListDataCopy[i])
        }
      }
    },

    // 表格有筛选的数据变化
    filterChange(filters) {
      console.log(filters)
      this.filters = JSON.parse(JSON.stringify(filters))
      this.mohuchaxun1()
    },

    eventshaixuaneventTypeselect1(e) {
      console.log(e)
    },
    mohuchaxun1(e) {
      var tabledata = JSON.parse(JSON.stringify(this.tableData2copy))
      var _this = this

      var tabledata1 = this.tableData2copy.filter(data => {
        return (String(data['dataName']).toLowerCase().indexOf(_this.zj_eventNames) > -1 ||
          String(data['dataKey']).toLowerCase().indexOf(_this.zj_eventNames) > -1 ||
          String(data['dataDesc']).toLowerCase().indexOf(_this.zj_eventNames) > -1)
      })
      if (_this.eventTypeselect1 == '') {
        var tabledata = tabledata1
      } else {
        var tabledata = tabledata1.filter(data => {
          return data['sysType'] == _this.eventTypeselect1
        })
      }

      if (_this.dataTypeselect1 == '') {
        var arr2 = tabledata
      } else {
        var arr2 = tabledata.filter(data => {
          return data['dataType'] == _this.dataTypeselect1
        })
      }

      // 表头筛选
      if (Object.keys(this.filters).length) {
        Object.keys(this.filters).forEach(head => {
          if (this.filters[head].length) {
            arr2 = arr2.filter(data => {
              return this.filters[head].includes(data[head])
            })
          }
        })
      }

      this.currentPage2 = 1
      this.tableData2 = arr2
      this.dataLength2 = arr2.length
    },
    zidianchange(e) {
      console.log(e)
    },

    rizhihuizongdata() {
      this.modelloading = true
      console.log()
      ajax_model4(
        {
          header_view_code: '3_1_1',
          header_time_type: this.rz_timetype
        },
        this.rz_querydata
      )
        .then(response => {
          if (response.code == 1) {
            console.log('日志', response)
            this.modelloading = false

            this.rz_tableData3 = response.data.data
            this.rz_dataLength3 = response.data.total

            this.rizhihuizongdataall()
          } else {
            alert(response.msg)
          }
          // console.log(response);
        })
        .catch(error => {
          console.log(error)
        })
    },
    rizhihuizongdataall() {
      ajax_model4(
        {
          header_view_code: '3_1_1',
          header_time_type: '0m'
        },
        {}
      )
        .then(response => {
          if (response.code == 1) {
            console.log('日志all', response)
            this.rz_jiezhihuizong = response.data.dataValue
          } else {
            alert(response.msg)
          }
          // console.log(response);
        })
        .catch(error => {
          console.log(error)
        })
    },
    rz_chakanxiangqing(index, row) {
      this.rz_shijianxiangqing = row.showTime + ' 详情'
      this.rz_dialogTableVisible = true
      var query_time = row.showTime + ' - ' + row.showTime
      this.rizhilistdata(query_time)
    },
    rizhilistdata(query_time) {
      this.modelloading1 = true
      ajax_model4(
        {
          header_view_code: '3_1_2',
          header_time_type: '1D',
          header_query_time: query_time
        },
        {}
      )
        .then(response => {
          if (response.code == 1) {
            console.log('日志详情', response)
            this.rz_tableData2copy = JSON.parse(JSON.stringify(response.data.data))
            this.rz_tableData2 = response.data.data
            this.rz_dataLength2 = response.data.data.tbody.length
          } else {
            alert(response.msg)
          }
          this.modelloading1 = false
          // console.log(response);
        })
        .catch(error => {
          console.log(error)
        })
    },

    handleAgeSortChange(e) {
      console.log(e)
      if (e.order == 'ascending') {
        var order = true
      } else if (e.order == 'descending') {
        var order = false
      }
      if (e.order == null) {
        this.rz_tableData2 = JSON.parse(JSON.stringify(this.rz_tableData2copy))
      } else {
        this.rz_tableData2.tbody.sort(this.sortBy(e.prop, order))
      }
    },
    sortBy(attr, rev) {
      // 第二个参数没有传递 默认升序排列
      if (rev == undefined) {
        rev = 1
      } else {
        rev = rev ? 1 : -1
      }

      return function (a, b) {
        // a = a[attr];
        // b = b[attr];
        if (!isNaN(Number(a[attr])) && !isNaN(Number(b[attr]))) {
          a = Number(a[attr])
          b = Number(b[attr])
        } else {
          a = a[attr]
          b = b[attr]
        }

        if (a < b) {
          return rev * -1
        }
        if (a > b) {
          return rev * 1
        }
        return 0
      }
    },

    rz_handleSizeChange2(e) {
      // table 分页数量变化
      this.rz_sizePage2 = e
    },
    rz_handleCurrentChange2(e) {
      // table 分页变化
      this.rz_currentPage2 = e
    },

    timetypehandleClick() {
      this.rz_querydata.pageNo = 1
      this.rizhihuizongdata()
    },
    handleRzSummaryPagination({ page, limit }) {
      const pageSizeChanged = limit !== this.rz_querydata.pageSize
      this.rz_querydata.pageSize = limit
      this.rz_querydata.pageNo = pageSizeChanged ? 1 : page
      this.rz_sizePage3 = limit
      this.rizhihuizongdata()
    },

    // 事件列表
    queryEventList() {
      this.modelloading2 = true
      var datas = {
        appkey: this.$store.getters.appkey,
        platformType: this.platformTypes,
        eventType: this.eventTypeselect,
        eventCode: this.eventNames,
        eventName: this.eventNames,
        isShow: this.isShows
      }

      ajax_eventqueryEventList(datas).then(
        response => {
          console.log('事件列表')
          console.log(response)
          if (response.code == 1) {
            this.tableData1 = response.data
            this.tableData1copy = JSON.parse(JSON.stringify(response.data))
            this.dataLength1 = response.data.length
          }
          this.modelloading2 = false
        }
      )
    },
    // 事件列表排序
    handleAgeSortChangeevent(e) {
      console.log(e)
      if (e.order == 'ascending') {
        var order = true
      } else if (e.order == 'descending') {
        var order = false
      }
      if (e.order == null) {
        this.tableData1 = JSON.parse(JSON.stringify(this.tableData1copy))
      } else {
        this.tableData1.sort(this.sortBy(e.prop, order))
      }
    },
    // 修改必传校验
    eventCheckchange(e, index, row, type) {
      var datas = {
        type: type,
        id: row.id,
        isCheck: e
      }
      ajax_eventupdateCheck(datas).then(
        response => {
          if (response.code == 1) {
            this.$message.success(response.msg)
          }
          this.queryEventDataList()
        }
      )
    },
    // 修改显示状态
    eventshowschange(e, index, row, type) {
      var datas = {
        type: type,
        id: row.id,
        isShow: e
      }
      ajax_eventupdateShow(datas).then(
        response => {
          if (response.code == 1) {
            this.$message.success(response.msg)
            row.isShow = e
          } else {
            row.isShow = !e
          }
          // if (type == "eventData") {
          //   this.queryEventDataList();
          // } else if (type == "event") {
          //   this.queryEventList();
          // }

        }
      )
    },
    // 添加自定义事件
    onSubmit() {
      if (this.form.platformType != 3 && Number.isInteger(parseInt(this.form.eventCode)) && parseInt(this.form.eventCode) > 30000) {
      } else if (this.form.platformType == 3) {
      } else {
        this.$message.error('事件编码必须为整数且大于30000的数字组成')
        return false
      }
      ajax_eventsaveEvent(this.form).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.queryEventList()
          this.adddivif = false
        }
      })
    },
    // 自定义事件编辑显示
    zidingyishijianupdate(index, row) {
      console.log(row)
      this.updatedivif = true
      this.uform = {
        id: row.id,
        appkey: this.$store.getters.appkey,
        eventCode: row.eventCode,
        platformType: row.platformType,
        eventName: row.eventName,
        eventDesc: row.eventDesc,
        isShow: row.isShow
      }
    },
    // 修改自定义事件
    onSubmituform() {
      console.log(this.uform)
      ajax_eventsaveEvent(this.uform).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.queryEventList()
          this.updatedivif = false
        }
      })
    },
    // 自定义事件删除
    zidingyishijiandelete(index, row) {
      this.$confirm('确认删除 "' + row.eventName + '" 吗？')
        .then(_ => {
          ajax_eventdeleteEventById({ id: row.id }).then(response => {
            console.log(response)
            if (response.code == 1) {
              this.$message.success(response.msg)
              this.queryEventList()
            }
          })
        })
        .catch(_ => { })
    },

    // 查看事件详情
    chakanxiangqing(index, row) {
      this.EventAttributeList()
      this.dialogTableVisible = true
      this.shijianxiangqing = '   事件编码：' + row.eventCode + ' （' + row.eventName + ')'
      this.eventcode = row.eventCode
      this.eid = row.id
      this.eventTypesis = row.eventType
      this.eventTypeselect1 = ''
      this.zj_eventNames = ''
      this.filters = {}
      this.queryEventDataList()
      if (this.$refs.detailTable) {
        this.$refs.detailTable.clearFilter()
      }
    },

    // 事件详情
    queryEventDataList() {
      ajax_eventqueryEventDataList({ id: this.eid }).then(response => {
        if (response.code == 1) {
          this.tableData2 = response.data
          this.tableData2copy = JSON.parse(JSON.stringify(response.data))
          this.dataLength2 = response.data.length

          this.shuxingquchong()
          this.mohuchaxun1()
        }
      })
    },
    // 自定义事件参数规则
    queryRuleList() {
      queryRuleList().then(response => {
        if (response.code == 1) {
          this.ruleTypes = response.data
        }
      })
    },
    // 自定义事件参数类型
    queryTypeList() {
      queryTypeList().then(response => {
        console.log(response)
        if (response.code == 1) {
          this.dataTypes = response.data

          for (var i = 0; i < response.data.length; i++) {
            this.dataTypesarr.push({
              text: response.data[i].dataTypeName,
              value: response.data[i].dataType
            })
          }
          console.log('自定义事件参数类型', this.dataTypesarr)
        }
      })
    },
    // 事件属性列表排序
    handleAgeSortChangeeventdata(e) {
      console.log(e)
      if (e.order == 'ascending') {
        var order = true
      } else if (e.order == 'descending') {
        var order = false
      }
      if (e.order == null) {
        this.tableData2 = JSON.parse(JSON.stringify(this.tableData2copy))
      } else {
        this.tableData2.sort(this.sortBy(e.prop, order))
      }
    },
    // 添加自定义事件属性
    baocunshijianshuxinglist() {
      var jiaoyan = /^[a-z][a-z0-9_]*$/g
      var regArr = []
      for (var i = 0; i < this.shijianshuxinglist.length; i++) {
        if (this.shijianshuxinglist[i].dataKey.match(jiaoyan) !== null) {
          regArr = regArr.concat(this.shijianshuxinglist[i].dataKey.match(jiaoyan))
        }

        // if(!jiaoyan.test(this.shijianshuxinglist[i].dataKey)){
        // if(this.shijianshuxinglist[i].dataKey.match(jiaoyan)){
        //   this.$message.error("参数名必须小写字母开头，包含小写字母、数字和下划线！！！");
        //   return false
        // } else {
        //   console.log('通过====')
        // }
      }

      // if (regArr.length !== this.shijianshuxinglist.length) {
      //   this.$message.error("参数名必须小写字母开头，只能由“小写字母”或 “小写字母+数字/下划线”组成");
      //   return false
      // }

      this.csform.sasEventCode = this.eventcode
      var datas = {
        appkey: this.$store.getters.appkey,
        sasEventCode: this.eventcode,
        list: this.shijianshuxinglist
      }
      console.log(datas)
      ajax_eventsaveEventDataList(datas).then(response => {
        console.log(response)
        if (response.code == 1) {
          if (response.data.code == 1) {
            this.$message.success(response.msg)
            this.queryEventDataList()
            this.adddivifcanshu = false
          } else {
            this.$message.warning('有异常参数，请修改后再进行保存')
            var reg = new RegExp('<br/>', 'g')
            response.data.data.forEach(item => {
              item.dataType += ''
              item.ruleType += ''
              item.dataEmpty += ''
              item.sysType += ''
              item.tipMessage = (item.tipMessage && item.tipMessage.indexOf('<br/>') > -1) ? item.tipMessage.replace(reg, '；&nbsp;&nbsp;&nbsp;&nbsp;') : ''
            })
            this.isUpload = true

            if (!this.UploadOrAdd) {
              this.uploadText = '添加事件属性'
            }

            this.shijianshuxinglist = response.data.data
          }
        }
      })
    },

    shijianshuxinglistadd() {
      this.shijianshuxinglist.push(JSON.parse(JSON.stringify(this.csform)))
    },
    shijianshuxinglistdelete(index, row) {
      console.log(index)
      this.shijianshuxinglist.splice(index, 1)
    },
    // 自定义事件属性编辑
    zidingyishijianshuxingupdate(index, row) {
      console.log(index, row)
      this.updatedivifcanshu = true
      this.dismiaoshu = row.sysType
      this.csuform = {
        id: row.id,
        appkey: this.$store.getters.appkey,
        sasEventCode: this.eventcode,
        dataKey: row.dataKey,
        dataType: row.dataType + '',
        dataName: row.dataName,
        dataDesc: row.dataDesc,
        dataEmpty: row.dataEmpty,
        isShow: row.isShow,
        ruleType: row.ruleType + '',
        sysType: row.sysType + '',
        isCheck: row.isCheck,
      }
    },
    // 修改自定义事件属性
    onSubmitcsuform() {
      console.log(this.csuform)
      ajax_eventsaveEventData(this.csuform).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.queryEventDataList()
          this.updatedivifcanshu = false
        }
      })
    },
    zidingyishijianshuxingdelete(index, row) {
      // 自定义事件属性删除
      this.$confirm('确认删除 "' + row.dataKey + '" 吗？')
        .then(_ => {
          ajax_eventdeleteEventDataById({ id: row.id }).then(response => {
            console.log(response)
            if (response.code == 1) {
              this.$message.success(response.msg)
              this.queryEventDataList()
            }
          })
        })
        .catch(_ => { })
    },
    filterplatformType(filters) {
      // 筛选所选项下的所有数据，需要调用后端接口
      console.log(filters)
      if (filters.platformType) {
        if (filters.platformType.length > 0) {
          this.platformTypes = filters.platformType[0]
        } else {
          this.platformTypes = ''
        }
      }

      if (filters.eventType) {
        if (filters.eventType.length > 0) {
          this.eventTypeselect = filters.eventType[0]
        } else {
          this.eventTypeselect = ''
        }
      }

      if (filters.isShow) {
        if (filters.isShow.length > 0) {
          this.isShows = filters.isShow[0]
        } else {
          this.isShows = ''
        }
      }

      // if (filters.isCheck) {
      //   if (filters.isCheck.length > 0) {
      //     this.isChecks = filters.isCheck[0]
      //   } else {
      //     this.isChecks = ''
      //   }
      // }
      this.queryEventList()
    },
    filterplatformType3(filters) {
      // 筛选所选项下的所有数据，需要调用后端接口
      console.log(filters.platformType)
      if (filters.platformType.length > 0) {
        this.platformTypeszidingyi = filters.platformType[0]
      } else {
        this.platformTypeszidingyi = ''
      }
    },
    // filterHandler(value, row, column) {
    //   const property = column['property'];
    //   console.log(row[property],value)
    //   return row[property] == value;
    // },

    eventshaixuanplatformTypes(e) {
      this.platformTypes = e
      this.currentPage1 = 1
      this.queryEventList()
    },
    eventshaixuaneventTypeselect(e) {
      this.eventTypeselect = e
      this.currentPage1 = 1
      this.queryEventList()
    },
    mohuchaxun() {
      this.currentPage1 = 1
      this.queryEventList()
    },

    adddivshow() {
      this.form = {
        appkey: this.$store.getters.appkey,
        eventCode: '',
        platformType: 1,
        eventName: '',
        eventDesc: '',
        isShow: true
      }

      this.adddivif = true
    },
    hidedivshow() {
      this.adddivif = false
    },
    hidedivshowuform() {
      this.updatedivif = false
    },
    hidedivshowcanshuadd() {
      this.adddivifcanshu = false
    },
    hidedivshowcanshuupdate() {
      this.updatedivifcanshu = false
    },
    hideeventdiv() {
      this.eventdivif = false
    },
    adddivshowcanshu() {
      this.isUpload = false
      this.UploadOrAdd = false
      this.adddivifcanshu = true
      this.shijianshuxinglist = [{
        dataKey: '',
        dataType: '1',
        dataName: '',
        ruleType: '0',
        dataEmpty: '1',
        dataDesc: '',
        isShow: true,
        sysType: '1',
        isCheck: true
      }]
    },
    handleSizeChange(e) {
      // table 分页数量变化
      this.sizePage = e
    },
    handleCurrentChange(e) {
      // table 分页变化
      this.currentPage = e
    },
    handleSizeChange1(e) {
      // table 分页数量变化
      this.sizePage1 = e
    },
    handleCurrentChange1(e) {
      // table 分页变化
      this.currentPage1 = e
    },
    handleSizeChange3(e) {
      // table 分页数量变化
      this.sizePage3 = e
    },
    handleCurrentChange3(e) {
      // table 分页变化
      this.currentPage3 = e
    },
    handleSizeChange4(e) {
      // table 分页数量变化
      this.sizePage4 = e
    },
    handleCurrentChange4(e) {
      // table 分页变化
      this.currentPage4 = e
    },
    exportExcel(e) {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(document.querySelector('#xiazaishijian'))
      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '事件列表.xlsx')
      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
      return wbout
    }
  },
  filters: {
    delFlags(value) {
      if (value == '0') {
        return '显示'
      } else if (value == '1') {
        return '隐藏'
      }
    },
    platformTypes(value) {
      if (value == '1') {
        return '服务端事件'
      } else if (value == '2') {
        return '客户端事件'
      } else if (value == '3') {
        return 'USDK埋点事件'
      }
    },
    eventTypes(value) {
      if (value == '0') {
        return '公共事件'
      } else if (value == '3') {
        return '必传参数'
      } else if (value == '1') {
        return '自定义事件'
      }
    },
    eventDescsub(value) {
      if (value.length > 25) {
        return value.substring(0, 25) + '...'
      } else {
        return value
      }
    },
    eventNamesub(value) {
      if (value.length > 10) {
        return value.substring(0, 10) + '...'
      } else {
        return value
      }
    },
    dataEmptys(value) {
      if (value == '0') {
        return '否'
      } else if (value == '1') {
        return '是'
      }
    },
    dataTypes(value, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (value == arr[i].value) {
          return arr[i].text
        }
      }
    },
    ispresets(value) {
      if (value == '0') {
        return '否'
      } else if (value == '1') {
        return '是'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-edit1 tr td .cell {
  padding: 0px 10px !important;
}

.el-table:not(.grayTableTile) th {
  background-color: #fff;
}

.el-table .warning-row {
  background: rgb(253, 225, 225);
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-message {
  z-index: 5000 !important;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>

